import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import ScrollRestoration from "react-scroll-restoration";

// --------------------------------------- Admin Components ----------------------------- //

import Login from "./admin/Login/login";
import Dashboard from "./admin/Dashboard/dashboard";
import Clients from "./admin/Clients/clients";
import ClientsDetails from "./admin/Clients/clientsDetails";
import CareTeam from "./admin/CareTeam/careteam";
import CareteamDetails from "./admin/CareTeam/careteamDetails";
import Shift from "./admin/ShiftTask/ShiftTask";
import Invoicing from "./admin/Invoicing/invoicing";
import SalesFunnel from "./admin/SalesFunnel/SalesFunnel";
import AccessRights from "./AccessRights/accessRights";
import Forgotpassword from "./admin/ForgotPassword/forgot-password";
import CreateShiftTask from "./admin/ShiftTask/CreateShiftTask";
import AddMedicines from "./admin/Medicines/addMedicines";
import Report from "./admin/Report/Report";
import Messaging from "./messaging/messaging";
import FromTemplate from "./admin/ShiftTask/FromTemplate";
import GenericShiftcreation from "./admin/ShiftTask/GenericShiftcreation";
import ClientShiftcreation from "./admin/ShiftTask/ClientSideshift";
import Header from "./admin/Header/header";
import Sidebar from "./admin/Sidebar/sidebar";
import Footer from "./admin/Footer/footer";
import UserRoleManagement from "./admin/UserRoleManagement/UserRoleManagement";
import SettingAceessModule from "./admin/UserRoleManagement/settingmoudles";
import ClientMedicinesWeekSchedule from "./admin/Medicines/clientSpeMedicWeekaddMedicines";
// ------------------------- Superadmin Components ------------------------- //

import SuperAdminHeader from "./superadmin/Header/header";
import SuperAdminFooter from "./superadmin/Footer/footer";
import SuperAdminSidebar from "./superadmin/Sidebar/sidebar";
import SuperAdminLogin from "./superadmin/Login/login";
import SuperAdminForgotpassword from "./superadmin/ForgotPassword/forgot-password";
import Analytics from "./superadmin/Analytics/analytics";
import Invoices from "./superadmin/Invoices/invoices";
import GeneralPlans from "./superadmin/SubscriptionPlans/generalPlans";
import AllActivity from "./superadmin/AllActivity/AllActivity";
import ContentManagement from "./superadmin/ContentManagement/ContentManagement";
import Support from "./superadmin/Support/Support";
import SuperAdminProfile from "./superadmin/Profile/Profile";
import Page from "./superadmin/detailpage/page";
import Customdatatable from "./components/customtable/customtable";
import ClientsOfSuperadmin from "./superadmin/superadmin-clients/superadmin-client.component";
import SuperClientDetails from "./superadmin/superadminroutes/clientdetails";
import Subscription from "./superadmin/Allsubscription/subscription";

import Payments from "./superadmin/Payments/payments";
import Reports from "./superadmin/Reports/reports";
import SubscriptionDetails from "./superadmin/Allsubscription/subscriptionDetails";
import EditPlanDetails from "./superadmin/Customtable/EditPlanDetails";
import EditCoupons from "./superadmin/Customtable/EditCoupons";
import EditAddOnDetails from "./superadmin/Customtable/EditAddOnDetails";
import SettingsDetails from "./superadmin/superadminroutes/settingsDetails";
import ProfileRoutes from "./admin/adminRoutes/ProfileRoutes";
import MultiStepSignupForm from "./admin/Signup/MultiStepSignupForm";
import ClientJournalAsApp from "./admin/Clients/ClientJournalAsApp";
import CardlessPaymentSuccess from "./admin/Signup/CardlessPaymentSuccess";
import InvoiceTemplate from "./superadmin/Settings/InvoiceTemplate";
import EmailTemplates from "./superadmin/Settings/EmailTemplates";
import StepFourSubscriptionPlan from "./admin/Signup/StepFourSubscriptionPlan";
// import FinalStepPaymentRedirection from "./admin/Signup/FinalStepPaymentRedirection";
import Payroll from "./admin/Payroll/Payroll";
// import OverviewDetails from "./admin/Payroll/OverviewDetails";
import VerifyUser from "./admin/verify/verify";

// ------------------------------ Performance Optimization Components ------------------------------ //
import ErrorBoundary from "./components/ErrorBoundary";
import { Suspense, useState, useEffect } from "react";
import DisaproveInvoice from "./superadmin/Invoices/DisaproveInvoice";
import WageOrDetail from "./admin/Payroll/WageOrDetail";
import SecurityQuestion from "./admin/securityQuestions/security";
import ResetPassword from "./admin/newPassword/newPassword";
import ForgotSecurityQuestion from "./admin/ForgotSecurityQuestion/ForgotSecurityQuestion";
import NewSecurityQuestion from "./admin/securityQuestions/newSecurityQuestion";
import { useDispatch, useSelector } from "react-redux";
import {
  careSitelisting,
  currentCareSiteIdHandler,
  selectCareSite,
} from "./redux-toolkit/reducer/switchSites";
import { restoreRefreshToken } from "./redux-toolkit/reducer/refreshToken_reducer";
import { restoreSuperadminRefreshToken } from "./redux-toolkit/reducer/superadminRefreshToken_reducer";
import { restorePortalRefreshToken } from "./redux-toolkit/reducer/portalRefreshToken_reducer";
import PredefinedTemplates from "./admin/Clients/CareplanTemplates/PredefinedTemplates";
import PredefinedQuestionAnswer from "./admin/Clients/CareplanTemplates/PredefinedQuestionAnswer";
import { db } from "./Firebase";
import { onSnapshot, collection } from "firebase/firestore";
import { updateCounter } from "./redux-toolkit/reducer/msgReducer";
import { ProductFruits } from "react-product-fruits";
import { toTitleCase } from "./utils/CommonFunctions";
import {
  getAccessRoles,
  getCareSiteListing,
} from "./redux-toolkit/reducer/caresiteDataReducer";
import PortalLogin from "./FandFamPortal/Authentication/Login";
import PortalHome from "./FandFamPortal/PortalHome";
import PortalMain from "./FandFamPortal/PortalMain";
import PortalChangePassword from "./FandFamPortal/Authentication/ChangePassword";
import ResetPortalPassword from "./FandFamPortal/Authentication/ResetPassword";
import NewPassword from "./FandFamPortal/Authentication/Password";
import CheckSecurityQuestion from "./FandFamPortal/Authentication/SecurtyQuestion";
import userProfile from "./FandFamPortal/UserProfile";
import requestService from "./FandFamPortal/RequestService";
import RequestServiceCalendar from "./FandFamPortal/RequestServiceCalendar";
import Feedback from "./FandFamPortal/Feedback";
import welcomeLogin from "./FandFamPortal/welcomeLogin";
import { getInvoiceData } from "./redux-toolkit/reducer/SuperAdminReducer";
import MultiSites from "./admin/multiSiteDash/MultiSites";
import PortalHeader from "./FandFamPortal/shared/Header";
import PortalFooter from "./FandFamPortal/shared/Footer";
import LogsTable from "./admin/eventLogs/LogsTable";

const PrivateRoute = (props) => {
  const care_admin_token = localStorage.getItem("care_admin_token");
  const currentCareSiteId = localStorage.getItem("currentCareSiteId");
  const userData = JSON.parse(localStorage.getItem("userData"));
  const dispatch = useDispatch();
  const { adminToken } = useSelector((state) => state.switchSites);
  const {
    adminTokenFromAuth,
    verifySuccessLogin,
    loginVerifyEmail,
    registerSuccess,
  } = useSelector((state) => state.accountCreationApiReducer);

  const { refreshToken } = useSelector((state) => state.refreshTokenReducer);
  const [timeoutId, setTimeoutId] = useState(null);
  let userInfo;

  if (userData) {
    let currentSite = userData.subscriptionPlanData.find(
      (item) => item._id === currentCareSiteId
    );
    let subPlan = currentSite?.SubscriptionPlan
      ? currentSite?.SubscriptionPlan
      : "";
    const planName = toTitleCase(subPlan);
    const uName = userData?.firstName + " " + userData?.lastName;
    const encodedName = customEncode(uName);
    userInfo = {
      username: encodedName,
      role: planName,
    };
  }

  function customEncode(inputString) {
    let encoded = "";
    for (let i = 0; i < inputString.length; i++) {
      const char = inputString.charAt(i);
      encoded +=
        char === " " ? " " : String.fromCharCode(char.charCodeAt(0) + 1);
    }
    return encoded;
  }

  const [axiosReady, setAxiosReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("care_admin_token");
    if (token && !window.axiosInterceptorsSetup) {
      import("./utils/axiosInterceptor").then(({ setupAxiosInterceptors }) => {
        setupAxiosInterceptors();
        window.axiosInterceptorsSetup = true;
        setAxiosReady(true);
      });
    } else {
      setAxiosReady(true);
    }
  }, []);

  useEffect(() => {
    // Set up token refresh when user is authenticated
    const care_admin_token = localStorage.getItem("care_admin_token");

    if (care_admin_token && refreshToken) {
      //console.log('[App] User is authenticated with refresh token, setting up token refresh mechanism');

      // Stop superadmin and portal token refresh systems when entering admin
      import("./utils/superadminTokenRefresh").then(
        ({ stopSuperadminTokenRefresh }) => {
          stopSuperadminTokenRefresh();
        }
      );

      import("./utils/portalTokenRefresh").then(
        ({ stopPortalTokenRefresh }) => {
          stopPortalTokenRefresh();
        }
      );

      // Import and setup token refresh timeout
      import("./utils/tokenRefresh").then(({ setupTokenRefreshInterval }) => {
        //console.log('[App] Setting up token refresh timeout');
        const newTimeoutId = setupTokenRefreshInterval();
        setTimeoutId(newTimeoutId);
      });
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        //console.log('[App] Cleaning up token refresh timeout:', timeoutId);
        clearTimeout(timeoutId);
      }
    };
  }, [refreshToken]); // Re-run when refreshToken changes

  useEffect(() => {
    const currentUserId = userData?._id ?? "";
    const unSub = onSnapshot(
      collection(db, "chatHeads", currentCareSiteId ?? "1111", "chatUsers"),
      (querySnapshot) => {
        const headdata = [];
        querySnapshot.forEach((doc) => {
          if (doc.exists()) {
            headdata.push(doc.data());
          }
        });
        let unseenMsgs = 0;
        if (headdata?.length > 0) {
          for (let i = 0; i < headdata.length; i++) {
            const counterData = headdata[i]?.counterMap?.find(
              (c) => c.id === currentUserId
            );
            if (counterData?.counter > 0) {
              unseenMsgs += 1;
            }
          }
          dispatch(updateCounter({ count: unseenMsgs }));
        }
      }
    );
    return () => {
      console.log("unsubscribe------");
      if (currentUserId) {
        unSub();
      }
    };
  }, []);

  useEffect(() => {
    const admin_token = localStorage.getItem("care_admin_token");
    if (admin_token) {
      dispatch(getCareSiteListing());
      setTimeout(() => {
        dispatch(getCareSiteListing());
      }, 3000);
    }
    if (userData?._id) {
      dispatch(getAccessRoles(userData?._id));
      setTimeout(() => {
        dispatch(getAccessRoles(userData?._id));
      }, 3000);
    }
    handleRequests();
  }, [
    adminToken,
    adminTokenFromAuth,
    verifySuccessLogin,
    loginVerifyEmail,
    registerSuccess,
  ]);

  async function handleRequests() {
    await dispatch(currentCareSiteIdHandler({ currentCareSiteId }));
    await dispatch(
      careSitelisting({
        id: currentCareSiteId ? currentCareSiteId : userData?.defaultCareSiteId,
      })
    );
    await dispatch(
      selectCareSite({
        id: currentCareSiteId ? currentCareSiteId : userData?.defaultCareSiteId,
      })
    );
  }
  // iRvazMxmeZ9EmHoE
  // aQ3W82M6KmtNgfNT
  if (!axiosReady) return null;
  return (
    <>
      {care_admin_token ? (
        <>
          <Header />
          <Sidebar />
          <Route {...props} />
          {userInfo && (
            <ProductFruits
              workspaceCode="aQ3W82M6KmtNgfNT"
              language="en"
              user={userInfo}
            />
          )}
          <Footer />
        </>
      ) : (
        <Redirect
          to={{
            pathname: "/login",
          }}
        />
      )}
    </>
  );
};

const PublicRoute = (props) => {
  const care_admin_token = localStorage.getItem("care_admin_token");

  return care_admin_token ? (
    <Redirect to={{ pathname: "/dashboard" }} />
  ) : (
    <Route {...props} />
  );
};

const PaymentRoute = (props) => {
  let care_admin_token = localStorage.getItem("careAdminToken");
  if (!care_admin_token)
    care_admin_token = localStorage.getItem("care_admin_token");

  return care_admin_token ? (
    <Route {...props} />
  ) : (
    <Redirect to={{ pathname: "/multistepsignupform" }} />
  );
};

const SuperAdminPrivateRoute = (props) => {
  const superadmin_token = localStorage.getItem("superadmin_token");
  const dispatch = useDispatch();
  const { refreshToken } = useSelector(
    (state) => state.superadminRefreshTokenReducer
  );
  const [timeoutId, setTimeoutId] = useState(null);

  // Restore superadmin refresh token from localStorage on component mount
  useEffect(() => {
    dispatch(restoreSuperadminRefreshToken());
  }, [dispatch]);

  // Setup axios interceptors for superadmin
  useEffect(() => {
    if (superadmin_token && !window.superadminAxiosInterceptorsSetup) {
      import("./utils/superadminAxiosInterceptor").then(
        ({ setupSuperadminAxiosInterceptors }) => {
          setupSuperadminAxiosInterceptors();
          window.superadminAxiosInterceptorsSetup = true;
        }
      );
    }
  }, [superadmin_token]);

  // Setup token refresh interval
  useEffect(() => {
    if (superadmin_token && refreshToken) {
      // Stop admin and portal token refresh systems when entering superadmin
      import("./utils/tokenRefresh").then(({ stopAdminTokenRefresh }) => {
        stopAdminTokenRefresh();
      });

      import("./utils/portalTokenRefresh").then(
        ({ stopPortalTokenRefresh }) => {
          stopPortalTokenRefresh();
        }
      );

      import("./utils/superadminTokenRefresh").then(
        ({
          setupSuperadminTokenRefreshInterval,
          clearSuperadminRefreshSchedule,
        }) => {
          // Clear any existing schedules first
          clearSuperadminRefreshSchedule();
          const newTimeoutId = setupSuperadminTokenRefreshInterval();
          setTimeoutId(newTimeoutId);
        }
      );
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Also clear the scheduled refresh when component unmounts
      import("./utils/superadminTokenRefresh").then(
        ({ clearSuperadminRefreshSchedule }) => {
          clearSuperadminRefreshSchedule();
        }
      );
    };
  }, [refreshToken, superadmin_token]);

  useEffect(() => {
    if (superadmin_token) {
      dispatch(getInvoiceData());
    }
  }, []);

  return (
    <>
      {superadmin_token ? (
        <>
          <SuperAdminHeader />
          <SuperAdminSidebar />
          <Route {...props} />
          <SuperAdminFooter />
        </>
      ) : (
        <Redirect
          to={{
            pathname: "/superadmin/login",
          }}
        />
      )}
    </>
  );
};

const SuperAdminPublicRoute = (props) => {
  const superadmin_token = localStorage.getItem("superadmin_token");

  return superadmin_token ? (
    <Redirect to={{ pathname: "/superadmin/dashboard" }} />
  ) : (
    <Route {...props} />
  );
};

const PortalPublicRoute = (props) => {
  const fandfam_token = localStorage.getItem("fandfam_token");

  return fandfam_token ? (
    <Redirect to={{ pathname: "/portal/portal-main" }} />
  ) : (
    <>
      <PortalHeader />
      <Route {...props} />
      <PortalFooter />
    </>
  );
};
const PortalPrivateRoute = (props) => {
  const fandfam_token = localStorage.getItem("fandfam_token");
  const dispatch = useDispatch();
  const { refreshToken } = useSelector(
    (state) => state.portalRefreshTokenReducer
  );
  const [timeoutId, setTimeoutId] = useState(null);

  // Restore portal refresh token from localStorage on component mount
  useEffect(() => {
    dispatch(restorePortalRefreshToken());
  }, [dispatch]);

  // Setup axios interceptors for portal
  useEffect(() => {
    if (fandfam_token && !window.portalAxiosInterceptorsSetup) {
      import("./utils/portalAxiosInterceptor").then(
        ({ setupPortalAxiosInterceptors }) => {
          setupPortalAxiosInterceptors();
          window.portalAxiosInterceptorsSetup = true;
        }
      );
    }
  }, [fandfam_token]);

  // Setup token refresh interval
  useEffect(() => {
    if (fandfam_token && refreshToken) {
      // Stop admin and superadmin token refresh systems when entering portal
      import("./utils/tokenRefresh").then(({ stopAdminTokenRefresh }) => {
        stopAdminTokenRefresh();
      });

      import("./utils/superadminTokenRefresh").then(
        ({ stopSuperadminTokenRefresh }) => {
          stopSuperadminTokenRefresh();
        }
      );

      import("./utils/portalTokenRefresh").then(
        ({ setupPortalTokenRefreshInterval, clearPortalRefreshSchedule }) => {
          // Clear any existing schedules first
          clearPortalRefreshSchedule();
          const newTimeoutId = setupPortalTokenRefreshInterval();
          setTimeoutId(newTimeoutId);
        }
      );
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Also clear the scheduled refresh when component unmounts
      import("./utils/portalTokenRefresh")
        .then(({ clearPortalRefreshSchedule }) => {
          clearPortalRefreshSchedule();
        })
        .catch(() => {
          // Ignore import errors
        });
    };
  }, [refreshToken, fandfam_token]);

  return (
    <>
      {fandfam_token ? (
        <>
          <PortalHeader />
          <Route {...props} />
          <PortalFooter />
        </>
      ) : (
        <Redirect
          to={{
            pathname: "/portal/login",
          }}
        />
      )}
    </>
  );
};

function App() {
  const dispatch = useDispatch();
  const { refreshToken } = useSelector((state) => state.refreshTokenReducer);
  const [timeoutId, setTimeoutId] = useState(null);

  // Restore refresh token from localStorage on app init
  useEffect(() => {
    // Import and setup axios interceptors at the top level
    // This ensures interceptors are set up before any API calls
    if (typeof window !== "undefined" && !window.axiosInterceptorsSetup) {
      const care_admin_token = localStorage.getItem("care_admin_token");
      if (care_admin_token) {
        //console.log('[App] Token exists, importing axios interceptors synchronously');
        import("./utils/axiosInterceptor").then(
          ({ setupAxiosInterceptors }) => {
            //console.log('[App] Setting up axios interceptors');
            setupAxiosInterceptors();
            window.axiosInterceptorsSetup = true;
          }
        );
      }
    }
    dispatch(restoreRefreshToken());
  }, [dispatch]);

  useEffect(() => {
    // Set up token refresh when user is authenticated
    const care_admin_token = localStorage.getItem("care_admin_token");

    // Only set up admin token refresh if we're actually on admin pages (not portal or superadmin)
    const isOnAdminPage =
      window.location.pathname.includes("/admin") &&
      !window.location.pathname.includes("/superadmin") &&
      !window.location.pathname.includes("/portal");

    if (care_admin_token && refreshToken && isOnAdminPage) {
      //console.log('[App] User is authenticated with refresh token, setting up token refresh mechanism');

      // Stop superadmin and portal token refresh systems when entering admin
      import("./utils/superadminTokenRefresh").then(
        ({ stopSuperadminTokenRefresh }) => {
          stopSuperadminTokenRefresh();
        }
      );

      import("./utils/portalTokenRefresh").then(
        ({ stopPortalTokenRefresh }) => {
          stopPortalTokenRefresh();
        }
      );

      // Import and setup token refresh timeout
      import("./utils/tokenRefresh").then(({ setupTokenRefreshInterval }) => {
        //console.log('[App] Setting up token refresh timeout');
        const newTimeoutId = setupTokenRefreshInterval();
        setTimeoutId(newTimeoutId);
      });
    } else if (care_admin_token && refreshToken && !isOnAdminPage) {
      // If we have admin token but we're not on admin page, stop admin token refresh
      import("./utils/tokenRefresh").then(({ stopAdminTokenRefresh }) => {
        stopAdminTokenRefresh();
      });
    }

    // Cleanup function
    return () => {
      if (timeoutId) {
        //console.log('[App] Cleaning up token refresh timeout:', timeoutId);
        clearTimeout(timeoutId);
      }
      // Also clear the scheduled refresh when component unmounts
      import("./utils/tokenRefresh")
        .then(({ clearRefreshSchedule }) => {
          clearRefreshSchedule();
        })
        .catch(() => {
          // Ignore import errors
        });
    };
  }, [refreshToken]); // Re-run when refreshToken changes

  // Add effect to handle route changes and stop appropriate token refresh systems
  useEffect(() => {
    const handleRouteChange = () => {
      const currentPath = window.location.pathname;

      if (currentPath.includes("/portal")) {
        // On portal pages, stop admin and superadmin token refresh
        import("./utils/tokenRefresh").then(({ stopAdminTokenRefresh }) => {
          stopAdminTokenRefresh();
        });
        import("./utils/superadminTokenRefresh").then(
          ({ stopSuperadminTokenRefresh }) => {
            stopSuperadminTokenRefresh();
          }
        );
      } else if (currentPath.includes("/superadmin")) {
        // On superadmin pages, stop admin and portal token refresh
        import("./utils/tokenRefresh").then(({ stopAdminTokenRefresh }) => {
          stopAdminTokenRefresh();
        });
        import("./utils/portalTokenRefresh").then(
          ({ stopPortalTokenRefresh }) => {
            stopPortalTokenRefresh();
          }
        );
      } else if (
        currentPath.includes("/admin") &&
        !currentPath.includes("/superadmin") &&
        !currentPath.includes("/portal")
      ) {
        // On admin pages, stop superadmin and portal token refresh
        import("./utils/superadminTokenRefresh").then(
          ({ stopSuperadminTokenRefresh }) => {
            stopSuperadminTokenRefresh();
          }
        );
        import("./utils/portalTokenRefresh").then(
          ({ stopPortalTokenRefresh }) => {
            stopPortalTokenRefresh();
          }
        );
      }
    };

    // Call once on mount
    handleRouteChange();

    // Listen for route changes (this works with React Router)
    const unlisten = window.addEventListener("popstate", handleRouteChange);

    return () => {
      if (unlisten) {
        window.removeEventListener("popstate", handleRouteChange);
      }
    };
  }, []); // Run once on mount

  return (
    <div>
      <ErrorBoundary fallback={<p>Something went wrong</p>}>
        <Suspense fallback={<div>loading ...</div>}>
          <Router basename="/admin">
            <ScrollRestoration />
            <Switch>
              {/* ----------------------------- Portal Routes -----------------------------  */}
              <PortalPublicRoute
                exact
                path="/portal/login"
                component={PortalLogin}
              />
              <PortalPublicRoute exact path="/portal" component={PortalHome} />
              <Route
                exact
                path="/portal/createPortalPassword"
                component={ResetPortalPassword}
              />
              <PortalPublicRoute
                exact
                path="/portal/password"
                component={NewPassword}
              />
              <PortalPublicRoute
                exact
                path="/portal/securityQuestion"
                component={CheckSecurityQuestion}
              />
              <PortalPublicRoute
                exact
                path="/portal/welcome-login"
                component={welcomeLogin}
              />

              <PortalPrivateRoute
                exact
                path="/portal/changePassword"
                component={PortalChangePassword}
              />
              <PortalPrivateRoute
                exact
                path="/portal/RequestServiceCalendar"
                component={RequestServiceCalendar}
              />
              <PortalPrivateRoute
                exact
                path="/portal/requestService"
                component={requestService}
              />
              <PortalPrivateRoute
                exact
                path="/portal/userProfile"
                component={userProfile}
              />
              <PortalPrivateRoute
                exact
                path="/portal/portal-main"
                component={PortalMain}
              />
              <PortalPrivateRoute
                exact
                path="/portal/Feedback"
                component={Feedback}
              />

              {/* ----------------------------- Admin Routes -----------------------------  */}

              <PublicRoute exact path="/login" component={Login} />
              <PublicRoute
                exact
                path="/security/:id"
                component={SecurityQuestion}
              />
              <PublicRoute
                exact
                path="/forgotsecurityquestion"
                component={NewSecurityQuestion}
              />
              <PublicRoute
                exact
                path="/app/forgotsecurityquestion"
                component={NewSecurityQuestion}
              />
              <PublicRoute
                exact
                path="/ff/forgotsecurityquestion"
                component={NewSecurityQuestion}
              />
              <PublicRoute exact path="/verify/:id" component={VerifyUser} />
              {/* <PublicRoute
                exact
                path="/admin/signup"
                component={MultiStepSignupForm}
              /> */}
              <PublicRoute
                exact
                path="/multistepsignupform"
                component={MultiStepSignupForm}
              />

              <PublicRoute
                exact
                path="/disapprove-invoice/:invoiceId"
                component={DisaproveInvoice}
              />

              <PaymentRoute
                exact
                path="/multistepsignupform/:registerType/:ownerId/:adminId/:trackId"
                component={CardlessPaymentSuccess}
              />

              <PaymentRoute
                exact
                path="/purchagePlan"
                component={StepFourSubscriptionPlan}
              />
              {/* <PaymentRoute
            exact
            path="/admin/payment"
            component={FinalStepPaymentRedirection}
          /> */}
              <PublicRoute
                exact
                path="/forgotpassword"
                component={Forgotpassword}
              />
              <PublicRoute
                exact
                path="/forgot-securityquestion"
                component={ForgotSecurityQuestion}
              />
              <PublicRoute
                exact
                path="/newPassword"
                component={ResetPassword}
              />
              <PublicRoute
                exact
                path="/app/newPassword"
                component={ResetPassword}
              />
              <PublicRoute
                exact
                path="/app/forgotpassword"
                component={Forgotpassword}
              />
              <PublicRoute
                exact
                path="/ff/newPassword"
                component={ResetPassword}
              />
              <PublicRoute
                exact
                path="/ff/forgotpassword"
                component={Forgotpassword}
              />
              <PrivateRoute path="/profile" component={ProfileRoutes} />
              <PrivateRoute path="/event-logs" component={LogsTable} />
              <PrivateRoute path="/multiSites" component={MultiSites} />
              <PrivateRoute
                exact
                path="/dashboard/:_id"
                component={Dashboard}
              />
              <PrivateRoute exact path="/" component={Dashboard} />
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute exact path="/clients" component={Clients} />

              <PrivateRoute exact path="/report" component={Report} />
              <PrivateRoute
                exact
                path="/fromtemplate"
                component={FromTemplate}
              />
              <PrivateRoute
                exact
                path="/genericshift"
                component={GenericShiftcreation}
              />
              <PrivateRoute
                exact
                path="/clientSideshift"
                component={ClientShiftcreation}
              />
              <PrivateRoute
                path="/clients/details"
                component={ClientsDetails}
              />
              <PrivateRoute
                exact
                path="/clientsdetails/:id/template"
                component={PredefinedTemplates}
              />
              <PrivateRoute
                exact
                path="/clientsdetails/:id/template2"
                component={PredefinedQuestionAnswer}
              />
              <PrivateRoute exact path="/careteam" component={CareTeam} />
              <PrivateRoute
                path="/careteam/details"
                component={CareteamDetails}
              />
              <PrivateRoute path="/shift" component={Shift} />
              <PrivateRoute
                exact
                path="/createshifttask"
                component={CreateShiftTask}
              />
              {/* <PrivateRoute exact path="/demo" component={DemoData} /> */}
              {/* <PrivateRoute
                exact
                path="/shiftTasks"
                component={PayrollShiftTask}
              /> */}
              <PrivateRoute path="/payroll" component={Payroll} />
              <PrivateRoute
                exact
                path="/paywages/:pageType/:clientId"
                component={WageOrDetail}
              />
              <PrivateRoute path="/emar" component={AddMedicines} />
              <PrivateRoute
                exact
                path="/clientweekschedule"
                component={ClientMedicinesWeekSchedule}
              />
              <PrivateRoute path="/invoicing" component={Invoicing} />
              <PrivateRoute
                exact
                path="/clientJournal"
                component={ClientJournalAsApp}
              />
              <PrivateRoute path="/salesfunnel" component={SalesFunnel} />
              <PrivateRoute
                exact
                path="/accessrights"
                component={AccessRights}
              />
              <PrivateRoute exact path="/messaging" component={Messaging} />
              <PrivateRoute
                exact
                path="/userole"
                component={UserRoleManagement}
              />
              <PrivateRoute
                exact
                path="/settings"
                component={SettingAceessModule}
              />
              {/* -------------------------------- Superadmin Routes  ---------------------------  */}
              <SuperAdminPublicRoute
                exact
                path="/superadmin/"
                component={SuperAdminLogin}
              />
              <SuperAdminPublicRoute
                exact
                path="/superadmin/login"
                component={SuperAdminLogin}
              />
              <SuperAdminPublicRoute
                exact
                path="/superadmin/forgotpassword"
                component={SuperAdminForgotpassword}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/dashboard"
                component={Analytics}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/clients"
                component={ClientsOfSuperadmin}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/subscription"
                component={Subscription}
              />
              <SuperAdminPrivateRoute
                path="/superadmin/settings"
                component={SettingsDetails}
              />
              <SuperAdminPrivateRoute
                path="/superadmin/invoiceTemplate"
                component={InvoiceTemplate}
              />
              <SuperAdminPrivateRoute
                path="/superadmin/emailTemplates/:templateType"
                component={EmailTemplates}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/clientdetails/:id/subscription/:subId"
                component={SubscriptionDetails}
              />
              <SuperAdminPrivateRoute
                path="/superadmin/clientdetails/:copanyName/:id"
                component={SuperClientDetails}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/invoices"
                component={Invoices}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/reports"
                component={Reports}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/reports/:dashboardCategory/:dashboardSubCategory"
                component={Reports}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/payments"
                component={Payments}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/plans"
                component={GeneralPlans}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/editAdd-On"
                component={EditAddOnDetails}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/editCoupons"
                component={EditCoupons}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/editPlan"
                component={EditPlanDetails}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/all-activity"
                component={AllActivity}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/content-management"
                component={ContentManagement}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/content-management/:_id"
                component={ContentManagement}
              />
              {/* <PopupContactList /> */}
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/support"
                component={Support}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/customtable"
                component={Customdatatable}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/page"
                component={Page}
              />
              <SuperAdminPrivateRoute
                exact
                path="/superadmin/profile"
                component={SuperAdminProfile}
              />

              {/* // -------------------------- Website Routes -------------------------- // */}

              <Route component={NotFound} />
            </Switch>
          </Router>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default App;

function customDecode(encodedString) {
  let decoded = "";
  for (let i = 0; i < encodedString.length; i++) {
    const char = encodedString.charAt(i);
    decoded += char === " " ? " " : String.fromCharCode(char.charCodeAt(0) - 1);
  }
  return decoded;
}

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
};
